import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import { transformResultsFromObject } from 'util/data';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const name = 'vmStates',
    exports = storeModuleFactory({
        name,
        endpoint:           endpoints.vmStates.endpoint,
        instanceEndpoint:   endpoints.vmStates.instanceEndpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: json => transformResultsFromObject(json.results)
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/vmStates.js